/* @flow */
import React from 'react';
import Text from 'components/Text.jsx';
import EventRSVPForm from 'payments/components/EventRSVPForm.jsx';

import './styles/ComposerEventRSVP.scss';

type Props = {
  onChange: () => void,
};

export default class ComposerEventRSVP extends React.Component {
  props: Props;

  render() {
    return (
      <div className="ComposerEventRSVP">
        <div className="ComposerEventRSVP-container">
          <Text element="div" className="ComposerEventRSVP-label" weight="bold">
            RSVP to join this conversation!
          </Text>
          <EventRSVPForm
            buttonSize="medium"
            onChange={this.props.onChange}
            disableSelectionChange
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/chat/components/ComposerEventRSVP.jsx